import { render, staticRenderFns } from "./ObjectDetailImage.vue?vue&type=template&id=6c871035&scoped=true&"
import script from "./ObjectDetailImage.vue?vue&type=script&lang=js&"
export * from "./ObjectDetailImage.vue?vue&type=script&lang=js&"
import style0 from "./ObjectDetailImage.vue?vue&type=style&index=0&id=6c871035&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c871035",
  null
  
)

export default component.exports